import React from 'react'

import { IconBase } from '../IconBase'
import { IconProps } from '../types'

export const XClose: React.FC<IconProps> = (props) => (
  <IconBase {...props}>
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
)
